import { Serializable, JsonProperty } from "typescript-json-serializer";
import { UserAuthInfo } from "../../domain/account/UserInfo";

@Serializable()
export class UserInfoDto {

    @JsonProperty() firstName?: string;

    @JsonProperty() lastName?: string;

    @JsonProperty() gender?: string;
    /** date of birth(dob) */
    @JsonProperty() dob?: Date | number;

    @JsonProperty() emailAddress?: string;
    
    @JsonProperty() isAllowUpdateUserName: boolean;
    
    @JsonProperty({type: UserAuthInfo}) authInfo?: UserAuthInfo;
    
    @JsonProperty() userName: string;
}